<template>
  <el-popover v-model="showModal" :visible-arrow="false" trigger="click">
    <div class="model-container">
      <div class="data-time-container">
        <div class="date-time-item">
          <select v-model="value[0]">
            <option :key="i" v-for="i in dayArr">{{ i }}</option>
          </select>
          <div class="date-text">{{ dayText }}</div>
        </div>
        <div class="date-time-item">
          <select v-model="value[1]">
            <option :key="i" v-for="i in hourArr">{{ i }}</option>
          </select>
          <div class="date-text">{{ hourText }}</div>
        </div>
        <div class="date-time-item">
          <select v-model="value[2]">
            <option :key="i" v-for="i in minArr">{{ i }}</option>
          </select>
          <div class="date-text">{{ minText }}</div>
        </div>
      </div>
      <div class="bottom-container">
        <hi-button @click="cancelClick" type="text" class="bulk-btn"
          >Cancel</hi-button
        >
        <hi-button @click="confirmClick" type="text" class="bulk-btn"
          >Done</hi-button
        >
      </div>
    </div>
    <div slot="reference">
      <div style="text-align: right">{{ datetimeFormat }}</div>
    </div>
  </el-popover>
</template>

<script>
import hiButton from "../button/Index";
import _ from "lodash";

export default {
  name: "DateIntervalSelectComponent",
  components: { hiButton },
  model: {
    prop: "model",
    event: "updateValue",
  },
  props: {
    model: {
      // 绑定值
      type: Array,
      default: () => {
        return [1, 1, 10];
      },
    },
  },
  methods: {
    cancelClick() {
      this.showModal = false;
      this.value = _.cloneDeep(this.model);
    },
    confirmClick() {
      if (
        Number(this.value[0]) === 0 &&
        Number(this.value[1]) === 0 &&
        Number(this.value[2]) === 0
      ) {
        this.$emit("updateValue", [0, 0, 10]);
      } else {
        this.$emit("updateValue", [
          Number(this.value[0]),
          Number(this.value[1]),
          Number(this.value[2]),
        ]);
      }
      this.showModal = false;
    },
  },
  data() {
    return {
      showModal: false,
      dayArr: [0, 1, 2, 3, 4, 5, 6, 7],
      hourArr: [
        0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
        20, 21, 22, 23, 24,
      ],
      minArr: [0, 10, 20, 30, 40, 50],
      value: _.cloneDeep(this.model),
    };
  },
  watch: {
    model(val) {
      this.value = _.cloneDeep(val);
    },
  },
  computed: {
    /**
     * day 格式化显示时间
     */
    dayText() {
      if (this.value[0] > 1) {
        return `days`;
      }
      return `day`;
    },
    /**
     * 小时 格式化显示时间
     */
    hourText() {
      if (this.value[1] > 1) {
        return `hours`;
      }
      return `hour`;
    },
    /**
     * 分钟 格式化显示时间
     */
    minText() {
      if (this.value[2] > 0) {
        return `mins`;
      }
      return `min`;
    },
    datetimeFormat() {
      const date = this.model;
      // 拼接日期
      let str = "";
      if (Number(date[0]) !== 0) {
        str += `${date[0]} ${this.dayText} `;
      }
      if (Number(date[1]) !== 0) {
        str += `${date[1]} ${this.hourText} `;
      }
      if (Number(date[2]) !== 0) {
        str += `${date[2]} ${this.minText}`;
      }
      return str;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import "../../assets/style/theme.less";

.model-container {
  .data-time-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    .date-time-item {
      display: flex;
      font-size: 17px;
      color: #000;
      width: 80px;
      select {
        text-align: center;
        text-align-last: center;
        width: 40px;
        border: 0;
        background: transparent;
        cursor: pointer;
        -webkit-appearance: none;
        line-height: 1;
        font-size: 16px;
        color: #000;
      }
    }
  }
  .bottom-container {
    display: flex;
    padding: 0 15px;
    justify-content: space-between;
    border-top: 1px solid @border-color;
    height: 50px;
    align-items: center;
    .bulk-btn {
      padding: 0;
      font-size: 16px;
      line-height: 1;
      color: @theme-color;
    }
  }
}
</style>
